<template>
    <nav :class="`grid c_${item.component.id}__buttons_outer_container c_${item.component.id}__buttons_outer_container_${theme_id ?? ''}`">
        <ul :class="`c_${item.component.id}__buttons_inner_container c_${item.component.id}__buttons_inner_container_${theme_id ?? ''}`">
            <li v-for="nav_item in nav_items" :key="nav_item.label">
              <button  :class="nav_item.nav == current_nav_item ? `c_${item.component.subcomponents.button.id}__button_active c_${item.component.subcomponents.button.id}__button_active_${theme_id ?? ''}` : `c_${item.component.subcomponents.button.id}__button c_${item.component.subcomponents.button.id}__button_${theme_id ?? ''}`" @click.prevent="current_nav_item = nav_item.nav">{{ nav_item.label }}</button>
          </li>
        </ul>
    </nav>
    <div :class="`grid c_${item.component.id}__information_outer_container c_${item.component.id}__information_outer_container_${theme_id ?? ''}`">
      <div :class="`grid c_${item.component.id}__information_inner_container c_${item.component.id}__information_inner_container_${theme_id ?? ''}`">  
          <div v-show="current_nav_item == 'description'"  :class="textClasses" v-html="description"></div>
          <div v-show="current_nav_item == 'features'"  :class="textClasses" v-html="features"></div>
          <div v-show="current_nav_item == 'specifications'"  :class="textClasses" v-html="specifications"></div>
          <div v-show="current_nav_item == 'warranty'"  :class="textClasses" v-html="warranty"></div>
          <div v-show="current_nav_item == 'shipping'"  :class="textClasses" v-html="shipping"></div>
          <div v-show="current_nav_item == 'documents'" >
            <ul class="">
              <li  v-for="document in product.documents?.filter(d => d.file_url) ?? []" :key="document.id">
                <a 
                  :href="`/storage/${document.file_url}`" 
                  download 
                  class="button button-secondary button-md" 
                >
                  {{ document.name }}
                </a>
              </li>
            </ul>
          </div>
      </div>
    </div>
  
</template>

<script>
import StringDecoder from "../services/stringDecoder";

export default {
  props: {
    product: Object,
    item: Object,
    theme_id: String|null,
  },

  data() {
    return {
      current_nav_item: 'description',
      nav_items: [],
      description: null,
      features: null,
      specifications: null,
      warranty: null,
      shipping: null,
    };
  },
  computed: {
    textClasses() {
      return `c_${this.item.component.subcomponents.text_block.id}_ c_${this.item.component.subcomponents.text_block.id}__${this.theme_id ?? ''} c_${this.item.component.subcomponents.text_block.subcomponents.link.id}_ c_${this.item.component.subcomponents.text_block.subcomponents.link.id}__${this.theme_id ?? ''} c_${this.item.component.subcomponents.text_block.subcomponents.table.id}_ c_${this.item.component.subcomponents.text_block.subcomponents.table.id}__${this.theme_id ?? ''}`
    }
  },
  mounted() {
    this.description = StringDecoder.decode(this.product?.description ?? "")
    this.features = StringDecoder.decode(this.product?.features ?? "")
    this.specifications = StringDecoder.decode(this.product?.specifications ?? "")
    this.warranty = StringDecoder.decode(this.product?.warranty_details?.description ?? "")
    this.shipping = StringDecoder.decode(this.product?.shipping_details?.description ?? "")
    if(this.description) {
      this.nav_items.push({
        label: 'Description',
        nav: 'description'
      })
    }
    if(this.features) {
      this.nav_items.push({
        label: 'Features',
        nav: 'features'
      })
    }
    if(this.specifications) {
      this.nav_items.push({
        label: 'Specifications',
        nav: 'specifications'
      })
    }
    if(this.shipping) {
      this.nav_items.push({
        label: 'Shipping & Collection',
        nav: 'shipping'
      })
    }
    if(this.warranty) {
      this.nav_items.push({
        label: 'Warranty & Returns',
        nav: 'warranty'
      })
    }
    if(this.product.documents?.length ?? false) {
      this.nav_items.push({
        label: 'Documents',
        nav: 'documents'
      })
    }
  },
};
</script>
